import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const MediaTitle = styled(Type)`
  &&:not(:last-child) {
    margin-bottom: 0;
  }
`;

export const MediaCopyright = styled(Type)`
  ${({ theme }) => `
    font-family: ${theme.font.family.base};
    color: ${theme.colors.gray800};
    font-size: ${theme.font.size.xs};
    font-weight: ${theme.font.weight.normal};
  `};

  line-height: 1.5;
`;

export const MediaImage = styled.img`
  max-height: 70vh;
  max-width: 100%;
`;
